/* eslint-disable indent */
/* eslint-disable no-undef */
export default {
	name: "customer-pricing",
	props: {
		companyId: {
			default: null
		}
	},
	data() {
		return {
			orderTypes: [],
			specialPricingMethods: [],
			products: [],
			zones: [],
			customers: [],
			productTypes: [],
			productType: {},
			customer: {},
			pagingDetails:{
				pageNumber: 1,
				pageSize: 10,
				totalPages: 1
			},
			actionKeys:{
				edit: "edit",
				markAsActiveInactive: "markAsActiveInactive"
			},
			specialPricingMethod: {},
			orderType: {},
			productAddEditFormModal:{
				showModal: false,
				isSaving: false,
				modalId: "addEditProductModal",
				heading: "Add Product",
				product: {
					productId: null,
					name: {
						value: null,
						hasError: false,
						errorMessage: null
					},
					price: {
						value: null,
						hasError: false,
						errorMessage: null
					},
					erpCode: {
						value: null,
						hasError: false,
						errorMessage: null
					},
					effectiveDate: {
						value: null,
						hasError: false,
						errorMessage: null
					},
					allowCollection: false,
					allowDelivery: false,
					allowCollectionDeliveryErrorMessage: null,
					allowCollectionDeliveryHasError: false
				},
				isUpdate: false
			},
			productMarkAsActiveInactiveModal:{
				showModal: false,
				isSaving: false,
				modalId: "markProductAsActiveInactiveModal",
				heading: "Mark Product As Active/Inactive",
				isActive: null,
				customerPricingId: null
			},
			filterStateChanged: false,
			filter:{
				zoneId: null,
				customerId: null,
				productId: null,
				customerSearchQuery: null,
				activeOrInactiveItems: 1,
				orderTypeId: null,
				specialPricingMethodId: null,
				canSearch: false
			},
			activeIsActiveKey:{
				active: 1,
				inactive: 0
			},
			loading: false,
			showDeliveryPricing: false,
			showDepotDiscountGroups: false,
			showDiscountGroups: false,
			showExTankPricing: false,
			showLinkingModalForDiscountGroups: false,
			showLinkingModalForDepotDiscountGroups: false,
			canAddOrEditPricing: false,
			canMarkAsActiveOrInactive: false
		};
	},
	methods: {
		getCustomerSpecialPricingPermissionsByRole(){
			this.loading = true;
			securityService.getCustomerSpecialPricingPermissionsByRole().then(
				successResponse => {
					console.log("successResponse", successResponse);
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.canAddOrEditPricing = successResponse.data.canAddOrEditPricing;
						this.canMarkAsActiveOrInactive = successResponse.data.canMarkAsActiveOrInactive;
					}
					this.loading = false;
				},
				errorResponse => {
					console.log("errorResponse", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		getSpecialPricingMethods() {
			this.specialPricingMethods = orderService.getSpecialPricingMethods(this.filter.orderTypeId);
			// this.specialPricingMethods.unshift(
			// 	{
			// 		specialPricingMethodId: 0,
			// 		description: "All"
			// 	});
			this.specialPricingMethods = $.map(this.specialPricingMethods,
				function (obj) {
					obj.id = obj.id || obj.specialPricingMethodId;
					obj.text = obj.text || obj.description;
					return obj;
				});
			this.filter.specialPricingMethodId = this.specialPricingMethods[0].id;
			this.onFilterSearchClicked();
		},
		getOrderTypes() {
			this.orderTypes = orderService.getOrderTypes();
			// this.orderTypes.unshift(
			// 	{
			// 		orderTypeId: 0,
			// 		description: "All"
			// 	});
			if(!this.customer.enableDeliveryOrders){
				this.orderTypes = this.orderTypes.filter(function(orderType){
					return orderType.orderTypeId !== orderHelper.orderType.delivery;
				});
			}
			if(!this.customer.enableCollectionOrders){
				this.orderTypes = this.orderTypes.filter(function(orderType){
					return orderType.orderTypeId !== orderHelper.orderType.collection;
				});
			}
			if(!this.customer.enableExTankOrders){
				this.orderTypes = this.orderTypes.filter(function(orderType){
					return orderType.orderTypeId !== orderHelper.orderType.exTank;
				});
			}
			console.log("orderTypes", this.orderTypes);
			this.orderTypes = $.map(this.orderTypes,
				function (obj) {
					obj.id = obj.id || obj.orderTypeId;
					obj.text = obj.text || obj.description;
					return obj;
				});
			this.filter.orderTypeId = this.orderTypes[0].id;
			this.onFilterSearchClicked();
			this.getSpecialPricingMethods();
		},
		getProducts(){
			this.loading = true;
			let request = {
				isActive: true,
				allowDelivery: true
			};
			productService.getProducts(request).then(
				successResponse => {
					console.log("successResponse", successResponse);
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						//success
						this.products = successResponse.data.result;
						this.products = dataTableHelper.castFieldValues(this.products);
						this.products.unshift(
							{
								productId: 0,
								name: "All"
							});
						this.products = $.map(this.products,
							function (obj) {
								obj.id = obj.id || obj.productId;
								obj.text = obj.text || obj.name;
								return obj;
							});
						this.filter.productId = 0;
						if(this.customers.length > 0 && this.zones.length > 0 && this.products.length > 0){
							this.getCustomerPricing()
						}
					}
					this.loading = false;
				},
				errorResponse => {
					console.log("errorResponse", errorResponse);
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		getZones() {
			this.loading = true;
			let request = {
				isActive: true
			};
			let fieldsToFilterBy = [
				{
					value: null,
					key: "description"
				}
			];
			let activeOnly = true;
			systemService.getZones(fieldsToFilterBy, request, false, activeOnly).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.zones = successResponse.data.result;
						this.zones = dataTableHelper.castFieldValues(this.zones);
						this.zones.unshift(
							{
								zoneId: 0,
								description: "All"
							});
						this.zones = $.map(this.zones,
							function (obj) {
								obj.id = obj.id || obj.zoneId;
								obj.text = obj.text || obj.description;
								return obj;
							});
						this.filter.zoneId = 0;
						if(this.customers.length > 0 && this.zones.length > 0 && this.products.length > 0){
							this.getCustomerPricing()
						}
					}
				},
				errorResponse => {
					console.log("error", errorResponse);
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		getCustomer(){
			let request = {
				companyId: this.companyId
			};
			customerService.getCompany(request).then(
				successResponse => {
					console.log("successResponse", successResponse);
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						//success
						this.customer = successResponse.data.result;
						this.getOrderTypes();
						this.setBreadcrumbs();
					}
				},
				errorResponse => {
					console.log("errorResponse", errorResponse);
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		onFilterSearchClicked(){
			console.log("Search filter clicked");
			this.filterStateChanged = false;
			this.showDeliveryPricing = false;
			this.showDepotDiscountGroups = false;
			this.showDiscountGroups = false;
			this.showExTankPricing = false;
			this.filter.canSearch = true;
			if(this.specialPricingMethod.customerPricingPerZone === this.filter.specialPricingMethodId){
				if(this.filter.orderTypeId === orderHelper.orderType.delivery) {
					this.showDeliveryPricing = true;
				}
				if(this.filter.orderTypeId === orderHelper.orderType.exTank){
					this.showExTankPricing = true;
				}
			}
			if(this.specialPricingMethod.discountGroups === this.filter.specialPricingMethodId){
				this.showDiscountGroups = true;
			}
			if(this.specialPricingMethod.depotDiscountGroups === this.filter.specialPricingMethodId){
				this.showDepotDiscountGroups = true;
			}
		},
		onSearchQueryInput(){
			this.filterStateChanged = true;
		},
		onActiveInactiveFilterSelected(activeOrInactiveKey){
			this.filter.activeOrInactiveItems = activeOrInactiveKey;
			this.filterStateChanged = true;
			console.log("filter", this.filter);
		},
		onSpecialPricingMethodFilterSelect(specialPricingMethod){
			if(this.filter.specialPricingMethodId !== specialPricingMethod.id){
				this.filter.specialPricingMethodId = specialPricingMethod.id;
				this.filterStateChanged = true;
			}
		},
		onOrderTypeFilterSelect(orderType){
			if(this.filter.orderTypeId !== orderType.id){
				this.filter.orderTypeId = orderType.id;
				this.filterStateChanged = true;
				this.getSpecialPricingMethods();
			}
		},
		onZoneFilterSelect(zone){
			console.log("zone", zone);
			if(this.filter.zoneId !== zone.id){
				this.filter.zoneId = zone.id;
				this.filterStateChanged = true;
			}
		},
		onCustomerFilterSelect(customer){
			if(this.filter.customerId !== customer.id){
				this.filter.customerId = customer.id;
				this.filterStateChanged = true;
			}
		},
		onLinkAndUnlinkDiscountGroupClick(){
			this.showLinkingModalForDiscountGroups = true;
		},
		onDiscountGroupLinkingModalClose(){
			this.showLinkingModalForDiscountGroups = false;
		},
		onLinkAndUnlinkDepotDiscountGroupClick(){
			this.showLinkingModalForDepotDiscountGroups = true;
		},
		onDepotDiscountGroupLinkingModalClose(){
			this.showLinkingModalForDepotDiscountGroups = false;
		},
		onGroupPricingPerZoneSearchComplete(){
			this.filter.canSearch = false;
		},
		setBreadcrumbs() {
			storeState.setPageTitleAction("Customer Pricing - " + this.customer.registeredCompanyName);
			var breadcrumbs = [];
			// var breadcrumbLogistics = {
			// 	url: null,
			// 	displayText: "Delivery"
			// };
			var driverManagementBreadcrumb = {
				url: this.$route.path,
				displayText: "Customer Pricing - " + this.customer.registeredCompanyName
			};
			// breadcrumbs.push(breadcrumbLogistics);
			breadcrumbs.push(driverManagementBreadcrumb);
			breadcrumbsStoreState.setBreadcrumbs(breadcrumbs);
		}
	},
	mounted: function () {
		this.specialPricingMethod = orderHelper.specialPricingMethod;
		this.orderType = orderHelper.orderType;
		this.getCustomerSpecialPricingPermissionsByRole();
		console.log("specialPricingMethod", this.specialPricingMethod);
		this.getZones();
		// this.getProducts();
		//this.getOrderTypes();
		// this.getProducts();

	},
	watch: {
		companyId: {
			handler: function () {
				if (this.companyId !== null && this.companyId > 0) {
					this.getCustomer();
				}
			},
			immediate: true,
			deep: true
		}
	}
};